import React from 'react';
import { UI_Modal, UI_Modal_project } from "../../UiComponents/index";
import { useNavigate } from "react-router-dom";

function SuccessModal(props) {
    const navigate = useNavigate();
    const {
        successModal, setSuccessModal, errorMesg, path, cloneMsg, setCloneMsg
    } = props;
    const handleClose = () => {
        if (path) {
            setSuccessModal(false)
            navigate(path)
        } else {
            setSuccessModal(false)
            if(cloneMsg){
                setCloneMsg('')
            }
        }
    }
    const closeModal = () => {
        setSuccessModal(false)
        if(cloneMsg){
            setCloneMsg('')
        }
    }
    return (
        <>
            <UI_Modal_project
                isOpen={successModal}
                closeModal={() => closeModal()}
                title={cloneMsg ? ' ' : ""}
            >
                <div className="m-3 flex justify-center items-center text-white text-xl">
                    <div className="sccess_text ">
                        <h1 className='Syne700 text-[26px]'>{errorMesg ? errorMesg : cloneMsg ? cloneMsg : 'Project Created Successfully'}</h1>
                    </div>
                </div>

                <div className="flex btn_container">
                    <button className="submit_btn_ui"
                        onClick={() => handleClose()}

                    >Close</button>
                </div>
            </UI_Modal_project>
        </>
    )
}

export default SuccessModal